/**
 * Category Slider Raf — centered frame, right peek cut, arrows on card edges
 */
(function () {
  'use strict';

  var MQ_DESKTOP = window.matchMedia('(min-width: 769px)');

  function readPeek(root, isDesktop) {
    var styles = window.getComputedStyle(root);
    var raw = styles.getPropertyValue(isDesktop ? '--catsraf-peek' : '--catsraf-peek-m').trim();
    var n = parseFloat(raw);
    if (!isFinite(n) || n <= 0) return isDesktop ? 0.4 : 0.38;
    /* schema stores 0–1 via divided_by 100, but guard if someone sets px-like */
    if (n > 1) n = n / 100;
    return Math.min(0.7, Math.max(0.15, n));
  }

  function init(root) {
    if (!root || root.dataset.catsrafReady === '1') return;
    root.dataset.catsrafReady = '1';

    var viewport = root.querySelector('[data-catsraf-viewport]');
    var track = root.querySelector('[data-catsraf-track]');
    var prev = root.querySelector('[data-catsraf-prev]');
    var next = root.querySelector('[data-catsraf-next]');
    if (!track || !viewport) return;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function stepSize() {
      var item = track.querySelector('.catsraf__item');
      if (!item) return Math.round(track.clientWidth * 0.7);
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return Math.round(item.getBoundingClientRect().width + gap);
    }

    function syncArrows() {
      var max = maxScroll();
      var left = track.scrollLeft;
      var canScroll = max > 2;
      if (prev) {
        prev.disabled = !canScroll || left <= 2;
        prev.hidden = !canScroll && MQ_DESKTOP.matches;
      }
      if (next) {
        next.disabled = !canScroll || left >= max - 2;
        next.hidden = !canScroll && MQ_DESKTOP.matches;
      }
    }

    /**
     * Size the centered viewport so the next circle is always clipped (peek),
     * and arrows sit on the outer corners of the visible card row.
     */
    function layout() {
      var items = track.querySelectorAll('.catsraf__item');
      var count = items.length;
      var inner = root.querySelector('.catsraf__inner');
      if (!inner || !count) {
        viewport.style.width = '';
        syncArrows();
        return;
      }

      var item = items[0];
      var itemW = item.getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var contentW = count * itemW + Math.max(0, count - 1) * gap;
      var available = inner.clientWidth;
      var isDesktop = MQ_DESKTOP.matches;
      var peekRatio = readPeek(root, isDesktop);
      var peekPx = Math.round(itemW * peekRatio);

      if (!isDesktop) {
        /* Mobile: full inner width; clip creates the right-side cut */
        viewport.style.width = '100%';
        var mobileFrame = Math.max(0, available);
        var mobileTarget = contentW - peekPx;
        if (count > 1 && contentW > mobileFrame) {
          /* natural overflow already peeks */
        } else if (count > 1 && mobileTarget > 0 && mobileTarget < contentW) {
          /* force peek when everything would otherwise fit */
          viewport.style.width = Math.min(mobileFrame, mobileTarget) + 'px';
        }
        syncArrows();
        return;
      }

      /* Desktop: centered frame that always cuts the next card when 2+ items */
      var frame = available;
      if (count > 1) {
        var withPeek = contentW - peekPx;
        if (contentW <= available) {
          /* All cards fit — shrink frame so the last one is cut */
          frame = Math.max(itemW + peekPx * 0.5, withPeek);
        } else {
          /* Wider than viewport — use full width; overflow peeks naturally.
             Still nudge frame down slightly if last card would land flush. */
          var rem = contentW - available;
          if (rem < peekPx * 0.5) {
            frame = Math.max(itemW, available - (peekPx - rem));
          } else {
            frame = available;
          }
        }
      } else {
        frame = Math.min(available, contentW);
      }

      frame = Math.min(available, Math.max(itemW, Math.round(frame)));
      viewport.style.width = frame + 'px';
      syncArrows();
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * stepSize(), behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByDir(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByDir(1);
      });
    }

    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', layout);
    if (MQ_DESKTOP.addEventListener) {
      MQ_DESKTOP.addEventListener('change', layout);
    } else if (MQ_DESKTOP.addListener) {
      MQ_DESKTOP.addListener(layout);
    }
    if (window.ResizeObserver) {
      new ResizeObserver(layout).observe(root.querySelector('.catsraf__inner') || root);
    }

    /* Images / fonts can change item width after first paint */
    window.requestAnimationFrame(function () {
      layout();
      window.setTimeout(layout, 50);
    });
  }

  function boot() {
    document.querySelectorAll('[data-catsraf]').forEach(function (el) {
      delete el.dataset.catsrafReady;
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-catsraf]');
    if (root) {
      delete root.dataset.catsrafReady;
      init(root);
    }
  });

  document.addEventListener('shopify:section:reorder', boot);
})();
